import { Select } from 'antd'
import { useMemo } from 'react'
import { useAuth } from 'src/context/auth.context'
import { useI18n } from 'src/context/i18n.context'

const OrganizationSwitcher = () => {
  const {
    branches = [],
    entities = [],
    activeBranchId,
    activeEntityId,
    setActiveBranchId,
    setActiveEntityId,
  } = useAuth()
  const { t } = useI18n()

  const branchOptions = useMemo(() => {
    const scopedBranches = activeEntityId
      ? branches.filter((branch) => branch.entity_id === activeEntityId)
      : branches

    return [
      { value: '__all__', label: t('common.allBranches') },
      ...scopedBranches.map((branch) => ({
        value: String(branch.id),
        label: branch.name,
      })),
    ]
  }, [activeEntityId, branches, t])

  if (!branches.length) {
    return null
  }

  return (
    <div className="flex items-center gap-2">
      <Select
        value={activeEntityId ? String(activeEntityId) : undefined}
        options={entities.map((entity) => ({
          value: String(entity.id),
          label: entity.name,
        }))}
        onChange={(value) => setActiveEntityId?.(parseInt(value))}
        placeholder={t('common.entity')}
        className="min-w-40"
      />
      <Select
        value={activeBranchId ? String(activeBranchId) : '__all__'}
        options={branchOptions}
        onChange={(value) => {
          if (value === '__all__') {
            setActiveBranchId?.(null)
            return
          }

          setActiveBranchId?.(parseInt(value))
        }}
        placeholder={t('common.branch')}
        className="min-w-40"
      />
    </div>
  )
}

export default OrganizationSwitcher
